import script from "./LWChart.vue?vue&type=script&setup=true&lang=js"
export * from "./LWChart.vue?vue&type=script&setup=true&lang=js"

import "./LWChart.vue?vue&type=style&index=0&id=03772210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03772210"]])

export default __exports__